/* eslint-disable @typescript-eslint/naming-convention */
export const textPartLanguageConfigModel = [
    { title: 'Arabic', languageCode: 'ar'},
    { title: 'Danish', languageCode: 'da' },
    { title: 'Dutch', languageCode: 'nl' },
    { title: 'English (US)', languageCode: 'en-US' },
    { title: 'English (UK)', languageCode: 'en-GB' },
    { title: 'Finnish', languageCode: 'fi' },
    { title: 'French', languageCode: 'fr' },
    { title: 'French (Canadian)', languageCode: 'fr-CA' },
    { title: 'German', languageCode: 'de' },
    { title: 'hebrew', languageCode: 'he'},
    { title: 'Italian', languageCode: 'it' },
    { title: 'Kurdish', languageCode: 'ku'},
    { title: 'Norwegian', languageCode: 'nb' },
    { title: 'Persian', languageCode: 'fa' },
    { title: 'Portuguese', languageCode: 'pt' },
    { title: 'Spanish', languageCode: 'es' },
    { title: 'Swedish', languageCode: 'sv' },
    { title: 'Uyghur', languageCode: 'ug'}
];

export const ckEditorLocalization = {
    'Font Family': 'Common.forms.richText.fontFamily',
    'Font Size': 'Common.forms.richText.fontSize',
    'Localization.lineHeight': 'Common.forms.richText.lineSpacing',
    'Localization.default': 'Common.forms.richText.default',
    'Heading': 'Common.forms.richText.heading',
    'Paragraph': 'Common.forms.richText.paragraph',
    'Heading 1': 'Common.forms.richText.headingOne',
    'Heading 2': 'Common.forms.richText.headingTwo',
    'Heading 3': 'Common.forms.richText.headingThree',
    'Bold': 'Common.forms.richText.bold',
    'Italic': 'Common.forms.richText.italic',
    'Underline': 'Common.forms.richText.underline',
    'Strikethrough': 'Common.forms.richText.strikeThrough',
    'Font Color': 'Common.forms.richText.fontColor',
    'Highlight Text': 'Common.forms.richText.highlightText',
    'Subscript': 'Common.forms.richText.subscript',
    'Superscript': 'Common.forms.richText.superscript',
    'Numbered List': 'Common.forms.richText.numberedList',
    'Bulleted List': 'Common.forms.richText.bulletList',
    'Text alignment': 'Common.forms.richText.alignment',
    'Align left': 'Common.forms.richText.leftAlign',
    'Align right': 'Common.forms.richText.rightAlign',
    'Align center': 'Common.forms.richText.centerAlign',
    'Justify': 'Common.forms.richText.justifyAlign',
    'Decrease indent': 'Common.forms.richText.decreaseIndent',
    'Increase indent': 'Common.forms.richText.increaseIndent',
    'Block quote': 'Common.forms.richText.blockquote',
    'Localization.link': 'Common.forms.richText.link',
    'Edit link': 'Common.forms.richText.editLink',
    'Unlink': 'Common.forms.richText.unlink',
    'Localization.openLinkInNewTab': 'Common.forms.richText.openLinkInNewTab',
    'Localization.hasNoUrl': 'Common.forms.richText.hasNoUrl',
    'Insert image': 'Common.forms.richText.insertImage',
    'Remove Format': 'Common.forms.richText.removeFormat',
    'Undo': 'Common.forms.richText.undo',
    'Redo': 'Common.forms.richText.redo',
    'Localization.moreOptions': 'Common.forms.richText.moreOptions',
    'Localization.selectLanguage': 'Common.forms.richText.selectLanguage',
    'Localization.removeLanguage': 'Common.forms.richText.removeLanguage',
    'Localization.languageTooltip': 'Common.forms.richText.languageTooltip',
    'Localization.personalizations': 'Common.forms.richText.personalizations',
    'Localization.translationTo': 'Common.forms.richText.translateTo',
    'Localization.translationToSpecific': 'Common.forms.richText.translateToSpecific'
};
